import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=70d857ec&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=70d857ec&lang=scss&scoped=true&"
import style1 from "./Client.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Client.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d857ec",
  null
  
)

export default component.exports